import React from 'react';
import AccessibilityIcon from '../icons/accessibility.svg';
import { useTranslation } from '../../../../i18n/translate/useTranslation';
import { useUrlForPageId } from '../../../../../app/pages/ui/utils/useUrlForPageId';
import { PassengersPageId } from '../../../../../app/pages/domain/constants/PageId';
import { StyledOverlayMenuItemLink } from '../../overlay/StyledOverlayMenuItem';
import { StyledMainNavListItemWrapper } from '../../main/StyledNavigationItems';

interface IAccessibilityButtonProps {
	isMobileView?: boolean;
}

export const AccessibilityButton = ({
	isMobileView,
}: IAccessibilityButtonProps) => {
	const { t } = useTranslation();
	const url = useUrlForPageId(PassengersPageId.Accessibility);

	return (
		<StyledMainNavListItemWrapper role={!isMobileView ? 'none' : undefined}>
			<StyledOverlayMenuItemLink
				href={url}
				aria-label={t('header_accessibility_label')}
				role={!isMobileView ? 'menuitem' : undefined}
			>
				<AccessibilityIcon
					id="accessibility"
					aria-label={t('header_accessibility_label')}
					role="img"
				/>
				{isMobileView && <span>{t('header_accessibility_label')}</span>}
			</StyledOverlayMenuItemLink>
		</StyledMainNavListItemWrapper>
	);
};
